<template>
  <el-dropdown>
    <el-button size="mini">
      Exportar
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item><span @click="exportData('csv')">CSV</span></el-dropdown-item>
      <el-dropdown-item><span @click="exportData('xls')">XLS</span></el-dropdown-item>
      <el-dropdown-item><span @click="exportData('html')">HTML</span></el-dropdown-item>
      <el-dropdown-item><span @click="exportData('xml')">XML</span></el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  methods: {
    exportData(fileType) {
      this.$emit('export', fileType)
    },
  }
}
</script>